// Core imports
import * as React from 'react';
import InvoiceService from 'src/services/invoice';

// Components imports
import RCheckbox from 'src/components/common/RCheckbox';

// Models imports
import InvoiceModel from 'src/model/invoice.model';

// Style and misc imports
import './MobileInvoiceCard.scss';

class MobileInvoiceCard extends React.Component<IMobileInvoiceCardProps, any> {
  /* 
    getInvoicePreview
   */
  private getInvoicePreview = () => {
    InvoiceService.downloadInvoice(
      this.props.invoice.invoiceNumber.toString(),
      this.props.invoice.invoiceDate.toString()
    ).then((response: any) => {
      const file = new Blob([response.data], { type: 'application/pdf' });
      const windowDownload = window.URL.createObjectURL(file);
      window.open(windowDownload);
    });
  };

  /* 
    statusFlagGetter : Reads the status and assign a css class 
   */
  private statusFlagGetter = (invoice: any) => {
    const flags = { type: '', icon: '' };
    switch (invoice.status) {
      case 'PAST DUE':
        flags.type = 'past-due';
        flags.icon = 'rpds-error';
        break;
      case 'DUE':
        flags.type = 'due';
        flags.icon = 'rpds-alert-bell';
        break;
      case 'PENDING':
        flags.type = 'pending';
        flags.icon = 'rpds-error warning';
        break;
      default:
      case 'PAID':
        flags.type = 'paid';
        flags.icon = 'rpds-check-circle';
        break;
    }

    return flags;
  };

  public render() {
    const { t, invoice } = this.props;
    const statusFlag = this.statusFlagGetter(invoice);

    return (
      <div className="rp-mobile-invoice-card">
        {/* status color */}
        <div
          className={`rp-mobile-invoice-card--status-flag ${statusFlag.type}`}
        >
          <span />
        </div>
        <div className="rp-mobile-invoice-card--data-container">
          {/* invoice number */}
          <div
            className={
              invoice.hasInvoice
                ? 'rp-mobile-invoice-card--order-number-clickable'
                : 'rp-mobile-invoice-card--order-number'
            }
            onClick={() => {
              if (invoice.hasInvoice) {
                this.getInvoicePreview();
              }
            }}
          >
            <span className="title">{t('invoices.invoiceNumberShort')}</span>
            <p className="value">{invoice.invoiceNumber}</p>
          </div>
          {/* due date */}
          <div className="rp-mobile-invoice-card--due-date">
            <span className="title">{t('invoices.dueDate')}</span>
            <p className="value">{invoice.dueDate}</p>
          </div>
          {/* due */}
          <div className="rp-mobile-invoice-card--due-status">
            <div className={`status-container ${statusFlag.type}`}>
              <i className={`${statusFlag.icon}`} />
              <p className="value">{invoice.status}</p>
            </div>
            <span
              className={`value ${statusFlag.type} ${
                invoice.remainingAmount < 0 ? 'green' : ''
              }`}
            >{`$${invoice.remainingAmount}`}</span>
          </div>
          {/* select */}
          <div className="rp-mobile-invoice-card--select">
            <RCheckbox
              id={`check${invoice.invoiceNumber}`}
              color="green"
              checked={this.props.isSelected}
              onChanged={() => {
                this.props.onInvoiceSelect(invoice);
              }}
              usesLabel={false}
              type="circle"
            />
          </div>
        </div>
        <div />
      </div>
    );
  }
}

export default MobileInvoiceCard;

interface IMobileInvoiceCardProps {
  onInvoiceSelect(invoices: InvoiceModel): void;
  t: any;
  invoice: InvoiceModel;
  isSelected: boolean;
}

/* interface IMobileInvoiceCardState {

} */
